import { useState, useEffect } from 'react';
import * as constants from 'Constants';
import { APP_VERSION } from 'config/version';

// Written by the backend on GET /version/update/ - see
// PlatformSettings.write_version_file(). Not the API: the footer reads the
// generated file, so it only changes when /version/update/ is called.
const VERSION_FILE_URL = `${constants.base_url}/media/version.json`;

/**
 * Hook that reads the deployed version from the generated version file.
 *
 * Falls back to the build-time version in config/version.js when the file has
 * not been generated yet (i.e. /version/update/ has never been called).
 *
 * @returns {{ version: Object|null, tag: string, commitHash: string }}
 */
export const useVersion = () => {
    const [version, setVersion] = useState(null);

    useEffect(() => {
        let cancelled = false;
        const fetchVersion = async () => {
            try {
                // cache-buster: /media/ is served with a long max-age
                const response = await fetch(`${VERSION_FILE_URL}?t=${Date.now()}`);
                if (!response.ok) {
                    throw new Error(`HTTP ${response.status}`);
                }
                const data = await response.json();
                if (!cancelled) setVersion(data);
            } catch (err) {
                console.error('Failed to read version file:', err);
            }
        };
        fetchVersion();
        return () => { cancelled = true; };
    }, []);

    return {
        version,
        tag: version?.latest_tag || APP_VERSION,
        commitHash: version?.latest_commit_short_hash || '',
    };
};

export default useVersion;
